import { Button } from '@repo/shadcn';
import { FC } from 'react';
import { z } from 'zod';

import { IwForm } from '@components/form';
import { TextField } from '@components/form/fields';
import { SectionTitle } from '@components/ui';

const BrandFormSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    description: z.string().optional(),
});

export type TBrandForm = z.infer<typeof BrandFormSchema>;

type BrandFormProps = {
    initialValues: TBrandForm;
    onSubmit?: (data: TBrandForm) => Promise<void>;
    isLoading?: boolean;
    title?: string;
};

export const BrandForm: FC<BrandFormProps> = ({
    initialValues,
    onSubmit,
    isLoading = false,
    title = 'Brand Form',
}) => {
    return (
        <div>
            <SectionTitle>{title}</SectionTitle>
            <IwForm
                schema={BrandFormSchema}
                initialValues={initialValues}
                onSubmit={onSubmit as any}
            >
                <div className={'flex flex-col space-y-4'}>
                    <TextField<TBrandForm>
                        name={'name'}
                        label={'Name'}
                        placeholder={'Enter brand name'}
                    />
                    <TextField<TBrandForm>
                        name={'description'}
                        label={'Description'}
                        placeholder={'Enter description'}
                    />

                    <div className={''}>
                        <Button type={'submit'} disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                    </div>
                </div>
            </IwForm>
        </div>
    );
};
